import React from 'react';
import { Link } from 'react-router-dom';
import usePageTitle from '../hooks/usePageTitle';
import './NotFound.css';

function NotFound() {
  usePageTitle('Página no encontrada');

  return (
    <div className="notfound-page">
      <div className="notfound-bg-glow"></div>
      <div className="notfound-content">
        <div className="notfound-code">404</div>
        <div className="notfound-icon">
          <i className="fas fa-camera-retro"></i>
        </div>
        <h1>¡Esta página no existe!</h1>
        <p>
          Parece que la cabina 360° no encontró este ángulo. <br />
          Vuelve al inicio y encuentra lo que buscas.
        </p>
        <div className="notfound-actions">
          <Link to="/" className="btn btn-primary btn-glow">
            <i className="fas fa-home"></i>
            Ir al inicio
          </Link>
          <Link to="/contacto" className="btn btn-outline">
            <i className="fab fa-whatsapp"></i>
            Contáctanos
          </Link>
        </div>
      </div>
    </div>
  );
}

export default NotFound;
